/*
* Copyright  2025-2026, Airspan
* All Rights Reserved
*
* This code is unpublished, confidential and proprietary to Airspan and may only be used in accordance with the appropriate
* license agreement. All other copying, modification, distribution, or
* reverse engineering are strictly prohibited.
*/

import { adddevicesNotoficationGroupColumns, devicesNotoficationGroupColumns } from "../../../Shared/Table/Columns";
import { DIALOGOPENFOR } from "../../../../globals/globals";
import { useDevices } from "./hooks";
import AssociationControl from "../../../Shared/Association/AssociationControl";
import { payloadKeyList } from "../../../Shared/Association/AssociationHelper";
import { IFilter } from "../../../Shared/Filter/types";
import { setResetAddDeviceFilters, setResetFilters } from "../../../../store/filters/devices/NotificationDeviceFilterReducer";
import DeviceDrawer from "../../../Drawers/DeviceDrawer";

interface DevicesProps {
    onAssociationChanged?: () => void;
}

const Devices: React.FC<DevicesProps> = ({ onAssociationChanged }) => {
    const {
        searchFilters,
        searchAddFilters,
        group
    } = useDevices();

    const removeDeviceFilters: IFilter = {
        searchTooltip: "",
        selectFilters: searchFilters
    };

    const addDeviceFilters: IFilter = {
        searchTooltip: "",
        selectFilters: searchAddFilters
    };

    return (
        <>
            <div className="flex-1 ml-3 mr-3">
                <AssociationControl
                    entity={group}
                    parentEntityName={"group"}
                    childEntityName={"Device"}
                    associationPermission={true}
                    listFilters={removeDeviceFilters}
                    listColumns={devicesNotoficationGroupColumns}
                    listSorting={"name, asc"}
                    listResetFilterHandler={setResetFilters}
                    listCheckboxSelection={true}
                    listDisableColumnMenu={true}
                    listDisableRowSelectionOnClick={true}
                    listMutationKey={"removeNotificationProfile"}
                    listMutationPayloadKey={payloadKeyList.removeNotificationProfile}
                    urlListParameterKey={"getNotificationMapProfile"}
                    loadListDataKey={"getNotificationMapProfile"}
                    listDialogOpener={DIALOGOPENFOR.REMOVENOTIFICATIONDEVICES}
                    addModelHeaderName={"Add device"}
                    visibleAdd={true}
                    addButtonName={"Add Device"}
                    showRemoveAction={true}
                    confirmRemoveDialogOpener={DIALOGOPENFOR.REMOVENOTIFICATIONDEVICES}
                    removeConfirmationMessage={"Are you sure you want to remove the selected device from group:"}
                    addFilters={addDeviceFilters}
                    addColumns={adddevicesNotoficationGroupColumns}
                    addSorting={"name, asc"}
                    addResetFilterHandler={setResetAddDeviceFilters}
                    showAddAction={false}
                    showAddAll={true}
                    addCheckboxSelection={true}
                    addDisableColumnMenu={true}
                    addDisableRowSelectionOnClick={true}
                    addMutationKey={"addNotificationProfile"}
                    addMutationPayloadKey={payloadKeyList.addNotificationProfile}
                    urlAddParameterKey={"getNotificationUnmapProfile"}
                    loadAddDataKey={"getNotificationUnmapProfile"}
                    loadAddAllDataKey={"getNotificationUnmapAllProfile"}
                    addShowInfoMessage={false}
                    onAssociationChanged={onAssociationChanged}
                    listHeight={"350px"}
                    listDrawerItem={DeviceDrawer}
                    isShowRemovePanelNotification={true}
                    notificationMessageforRemove={"Each device can belong to at most one notification group. Moving a device here removes it from any other group."}
                />
            </div>
        </>
    );
};


export default Devices;